import { render } from "./Emoji.vue?vue&type=template&id=1fc6cb4c"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"

import "./Emoji.vue?vue&type=style&index=0&id=1fc6cb4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__